import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_SimulationDemoEvent } from './db-def.js';
export const ApiDef_SimulationDemoEvent = {
    _v1: {
        getEncounterData: { method: HttpMethod.POST, path: `v1/${DBDef_SimulationDemoEvent.dbKey}/get-encounter-data` },
    }
};
//# sourceMappingURL=api-def.js.map